import React, { useRef } from 'react';
import RiskAssessmentForm from '../components/RiskAssessment/RiskAssessmentForm';

const RiskAssessmentPage = () => {
    return (
        <RiskAssessmentForm />
    );
};

export default RiskAssessmentPage;